import { render } from "./Attendfamily.vue?vue&type=template&id=6e2742c7"
import script from "./Attendfamily.vue?vue&type=script&lang=js"
export * from "./Attendfamily.vue?vue&type=script&lang=js"

import "./Attendfamily.vue?vue&type=style&index=0&id=6e2742c7&lang=css"

import exportComponent from "/var/www/html/youthmanna/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__